import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { Button } from "@ui/components/forms/button/Button";
import { useRouter } from "next/router";

const LiveChat = () => {
    const { showModal } = useGlobalModalContext();

    const formHandler = async () => {
        const chatEnabled = isChatAgentAvailable();
        if (chatEnabled) {
            return showModal(ModalTypes.liveChat);
        } else {
            return showModal(ModalTypes.chatIsNotAvailable);
        }
    };

    const { get: getMicrocopy } = useMicrocopy();

    const { pathname } = useRouter();
    const isCustomerServicePage = pathname.includes("customer-service");

    return (
        isCustomerServicePage &&
        !isChatInProgress() && (
            <Button
                variant={"solid"}
                onClick={formHandler}
                size={"md"}
                sx={{
                    position: "fixed",
                    height: "10",
                    right: ["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"],
                    bottom: 0,
                    zIndex: 7,
                }}
                data-testid={"LiveChatButton"}
            >
                <span>{getMicrocopy(CommonCMS.shared, CommonCMS.liveChat.needHelp)}</span>
            </Button>
        )
    );
};

export default LiveChat;

export function isChatAgentAvailable() {
    const button = document.querySelector("button.uiButton.helpButtonEnabled");
    return !!button;
}

export function isChatInProgress() {
    const collapsedChat = document.querySelector("button.embeddedServiceSidebarMinimizedDefaultUI");
    const chat = document.querySelector(".embeddedServiceSidebar");
    return !!collapsedChat || !!chat;
}
